import PropertyTableRowModel from '../components/Underwriting/components/PropertyTable/PropertyTableRowModel';
import { addTriaPremiumToRatedPremium, calculateTotalPolicyPremiumFromLocations } from './calculations';

export const calculateGLPremium = (irpm?: number, baseRatedPremium?: number) => {
    if (!baseRatedPremium) return 0;
    // @ts-ignore
    const cdDb = irpm === '' ? 0 : irpm || 0;
    // Note: removing the * 1000 / 1000 up the rounding
    // rates go to the tenth of a penny
    return Math.round((baseRatedPremium * cdDb + 0.00001) * 1000) / 1000;
};

export const calculateTotalGLPremium = (irpm?: number, baseRatedPremium?: number, triaPercentage?: number) => {
    return addTriaPremiumToRatedPremium(calculateGLPremium(irpm, baseRatedPremium), triaPercentage);
};


export const calculateTotalGLPolicyPremium = (
    locations: PropertyTableRowModel[],
    HNOPremium: number,
    triaPercentage: number
) => {
    const locationSumPremium = calculateTotalPolicyPremiumFromLocations(locations);
    const hno = addTriaPremiumToRatedPremium(HNOPremium, triaPercentage);
    return locationSumPremium + hno;
};

